import {
  SEGMENT_PAYMENT,
  SEGMENT_PAYMENTPLAN,
  stripePromise,
} from "../store/constants";
import { formatDollars } from "../util/stripe";
import { Elements } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useBlocker } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import Box from "./Box";
import CashierMessage from "./CashierMessage";
import PaymentForm from "./PaymentForm";
import PaymentPlanForm from "./PaymentPlanForm";
import ScheduledPaymentsPane from "./ScheduledPaymentsPane";
import SegmentButtons from "./SegmentButtons";

function Prompt(props) {
  const block = props.when;
  useBlocker(() => {
    if (block) {
      return !window.confirm(props.message);
    }
    return false;
  });
  return <div key={block} />;
}

// the actual form must be wrapped in an Elements component containing the stripe promise.
const FormWrapper = () => {
  const { deal } = useSelector((state) => state.cashier);

  const [cleanForm, setCleanForm] = useState(true);

  const formFocusHandler = (clean) => {
    setCleanForm(clean);
  };

  const [selectedSegment, setSelectedSegment] = useState(SEGMENT_PAYMENT);
  const [message, setMessage] = useState(null);

  const chooseSegment = (segment) => {
    setSelectedSegment(() => segment);
  };

  const displayPane = (chosenSegment) => {
    switch (chosenSegment) {
      case SEGMENT_PAYMENTPLAN:
        return (
          <PaymentPlanForm
            formClean={formFocusHandler}
            setMessage={setMessage}
          />
        );
      case SEGMENT_PAYMENT:
      default:
        return (
          <PaymentForm formClean={formFocusHandler} setMessage={setMessage} />
        );
    }
  };

  return (
    <>
      <div className="mx-auto flex w-full gap-3 px-4 xl:container">
        {/* Sticky!? In case the right pane is much higher than the left, scroll only right pane */}
        <Box className="sticky w-full" outerClassName="w-6/12">
          {/* current amount */}
          {selectedSegment === SEGMENT_PAYMENT &&
            typeof deal?.amount !== "undefined" && (
              <div className="flex w-full flex-row text-gray-700">
                Deal current amount: {formatDollars(deal?.amount || 0)}
              </div>
            )}

          {/* Segment buttons */}
          <SegmentButtons
            chooseSegment={chooseSegment}
            selectedSegment={selectedSegment}
          />

          <Prompt
            when={!cleanForm}
            message={() =>
              "Are you sure to leave this page and lose the entered information?"
            }
          />

          <Elements stripe={stripePromise} className="flex flex-col">
            {displayPane(selectedSegment)}
            {message && (
              <CashierMessage
                className={twMerge(
                  "text-center",
                  message.ok ? "text-green-500" : "text-red-500",
                )}
              >
                {message.text}
                {message.warningText && (
                  <div className="border border-black bg-yellow-100">
                    {message.warningText}
                  </div>
                )}
              </CashierMessage>
            )}
          </Elements>
        </Box>

        <div className="flex w-full flex-1 flex-col">
          <Box className="w-full px-4">
            <ScheduledPaymentsPane />
          </Box>
        </div>
      </div>
    </>
  );
};

export default FormWrapper;
